"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
function debounceError(error) {
    return { type: 'error', error };
}
exports.debounceError = debounceError;
function debounceOk() {
    return { type: 'ok' };
}
exports.debounceOk = debounceOk;
function errorDebounceOperator({ debounceMs }) {
    return (input$) => {
        const higher = input$.pipe(operators_1.switchMap(win => rxjs_1.of(win).pipe(operators_1.delay(debounceMs))));
        const inner = higher.pipe(operators_1.startWith({ type: 'ok' }), // start with ok, so distinctUntilChanged won't emit first ok
        operators_1.distinctUntilChanged((x, y) => x.type === y.type), // do not emit the same value
        operators_1.skip(1)); // skip the first 'ok'
        return inner;
    };
}
exports.errorDebounceOperator = errorDebounceOperator;
//# sourceMappingURL=error-debouncer-operator.js.map